const defaultCrypto = {
  decimals: 18,
  img: require("@/assets/images/crypto/ETH.svg"),
  name: "Ethereum",
  subtext: "Ethereum",
  value: "ETH",
  symbol: "ETH",
  network: "ETH",
};

const defaultFiat = {
  name: "USD",
  value: "USD",
  img: require("@/assets/images/fiat/USD.svg"),
};

export {
  defaultCrypto,
  defaultFiat
}